import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import API from "@/lib/api";
import { checkAndCelebrateMilestones } from "@/lib/milestones";

/**
 * Small green "N DAYS SYMPTOM-FREE" pill on the web dashboard mirroring
 * the mobile SymptomCheckInCard badge. Also acts as the entry point that
 * fires all celebratory milestone toasts (symptom-free streak 7/30 +
 * weight-halfway + first-month-subscribed) via `checkAndCelebrateMilestones`.
 */
export default function SymptomStreakBadge({ className = "" }) {
  const [streak, setStreak] = useState(null);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await API.get("/wellness/no-symptom-streak");
        if (!cancelled && data && typeof data.days === "number") setStreak(data);
      } catch { /* dashboard shouldn't break on this */ }
    })();
    // Fire the multi-milestone check in parallel — no need to await.
    checkAndCelebrateMilestones();
    return () => { cancelled = true; };
  }, []);

  if (!streak?.eligible) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-emerald-500 text-white px-2.5 py-0.5 text-[10px] font-bold tracking-wider ${className}`}
      data-testid="symptom-streak-badge"
    >
      <Sparkles className="w-3 h-3" />
      {streak.days} DAYS SYMPTOM-FREE
    </span>
  );
}
